import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { IApplicationState } from '@Site/rootReducer'
import Popup from '@SiteComponents/Popup'
import CreateLabelForm from '@SiteComponents/CreateLabelForm'

import {
  createLabel
} from '@SiteModules/Label/actions'

import {
  ICreateLabelPayload
} from '@SiteModules/Label/types'

import './CreateLabelPopup.scss'

interface CreateLabelPopupProps {
  readonly loading: boolean
  readonly currentWorkspaceId: number
  closePopup(): void
  createLabel(payload: ICreateLabelPayload): void
}

interface CreateLabelPopupState {
}

class CreateLabelPopup extends React.Component<CreateLabelPopupProps, CreateLabelPopupState> {
  render() {
    const { closePopup, loading, currentWorkspaceId } = this.props

    return (
      <Popup
        className="CreateLabelPopup"
        closePopup={closePopup}
      >
        <div className="CreateLabelPopup__title">Create new label</div>
        <CreateLabelForm
          showSpinner={loading}
          disableButton={loading}
          submit={this.props.createLabel}
          currentWorkspaceId={currentWorkspaceId}
        />
      </Popup>
    )
  }
}

function mapStateToProps(state: IApplicationState) {
  return {
    loading: state.labels.loading,
    currentWorkspaceId: state.workspaces.currentWorkspaceId,
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return bindActionCreators({
    createLabel,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateLabelPopup)
